// extracted by mini-css-extract-plugin
module.exports = {"roleMenuItem":"styles_roleMenuItem__u0a0G","menuItem":"styles_menuItem__MYksA"};